import Button from '@jetbrains/ring-ui/components/button/button'

import EditSettingsForm from '../../../../../components/EditSettingsForm/EditSettingsForm'
import PipelineParameterFormFieldset from '../PipelineParameterFormFieldset/PipelineParameterFormFieldset'

import type {PipelineParameterCreateFormProps} from './PipelineParameterCreateForm.types'
import usePipelineParameterCreateForm from './usePipelineParameterCreateForm'

import styles from './PipelineParameterCreateForm.css'

function PipelineParameterCreateForm({onDeleteAll, onConfirm}: PipelineParameterCreateFormProps) {
  const {
    isFormInvalid,
    newParameterNames,
    newParameterForms,
    validFormFieldsetHandler,
    changeFormFieldsetHandler,
    confirmFormButtonClickHandler,
    deleteFormButtonClickHandler,
    addParameterButtonClickHandler,
    keyPressParameterInputHandler,
    deleteParameterButtonClickHandler,
  } = usePipelineParameterCreateForm(onDeleteAll, onConfirm)

  return (
    <EditSettingsForm
      onConfirmClick={confirmFormButtonClickHandler}
      onDeleteClick={deleteFormButtonClickHandler}
      deleteTitle="Delete all added parameters"
      title="Adding new parameters"
      disabled={isFormInvalid}
    >
      {newParameterForms.map(({name, value, id}, index) => {
        const isFirstParaneterFormFieldset = index === 0

        return (
          <div key={id} className={styles.paraneterForm}>
            <PipelineParameterFormFieldset
              name={name}
              value={value}
              parameterNames={newParameterNames}
              onKeyPress={keyPressParameterInputHandler}
              onChange={changeFormFieldsetHandler(index)}
              onValid={validFormFieldsetHandler(index)}
              onDelete={deleteParameterButtonClickHandler(index)}
            />
            {isFirstParaneterFormFieldset && (
              <div className={styles.helpText}>{'Optional prefix: env., system. or teamcity'}</div>
            )}
          </div>
        )
      })}
      <Button
        inline
        text
        onClick={addParameterButtonClickHandler}
        className={styles.addParameterButton}
      >
        {'Add parameter'}
      </Button>
    </EditSettingsForm>
  )
}

export default PipelineParameterCreateForm
